import { Space, Table, TableColumnProps, TableProps, Tag, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

import { RequestJobPostingCollection } from '../../types';
import { calculateOpenDays } from '../../utils';

interface Props extends TableProps<RequestJobPostingCollection> {
  actionsRender: NonNullable<TableColumnProps<RequestJobPostingCollection>['render']>;
}

const RequestJobPostingTable: React.FC<Props> = ({ actionsRender, ...props }) => {
  return (
    <Table rowKey="id" {...props}>
      <Table.Column
        title="Requisições"
        render={(_value, record: RequestJobPostingCollection) => (
          <>
            <Space direction="horizontal">
              <Link to={`${record.id}`} className="ant-typography-link">
                {`${record.id} - ${record.name}`}
              </Link>
            </Space>
            <br />
            <Typography.Text type="secondary">
              {`Dias em aberto: ${calculateOpenDays(record.created_at)}`}
            </Typography.Text>
          </>
        )}
      />
      <Table.Column
        title="Status das requisições"
        align="center"
        render={(_, record: RequestJobPostingCollection) => (
          <>
            {record.status === 'IN_PROGRESS' && <Tag color="processing">Em andamento</Tag>}
            {record.status === 'NOT_INITIATED' && <Tag color="default">Não iniciada</Tag>}
            {record.status === 'CANCELED' && <Tag color="default">Cancelada</Tag>}
            {record.status === 'REJECTED' && <Tag color="error">Reprovada</Tag>}
            {record.status === 'APPROVED' && <Tag color="success">Aprovada</Tag>}
          </>
        )}
      />
      <Table.Column
        title="Modelo de requisição"
        colSpan={1}
        align="center"
        dataIndex="id"
        render={(_value, record: RequestJobPostingCollection) => (
          <Typography.Text>{record.template_name}</Typography.Text>
        )}
      />
      <Table.Column
        title="Unidade"
        colSpan={1}
        align="center"
        dataIndex="id"
        render={(_id, record: RequestJobPostingCollection) => (
          <Typography.Text>{record.branch || '-'}</Typography.Text>
        )}
      />
      <Table.Column
        title="Aprovação"
        colSpan={1}
        align="center"
        render={(_value, record: RequestJobPostingCollection) => (
          <Typography.Text>
            {record.approved_stages_count}/{record.stages_count}
          </Typography.Text>
        )}
      />
      <Table.Column
        title="Requisitante"
        colSpan={1}
        align="center"
        dataIndex="id"
        render={(_id, record: RequestJobPostingCollection) =>
          record.claimant.is_staff ? (
            <Typography.Text>Sistema</Typography.Text>
          ) : (
            <Typography.Text>{record.claimant.full_name}</Typography.Text>
          )
        }
      />
      <Table.Column title="Ações" align="center" render={actionsRender} />
    </Table>
  );
};
export default RequestJobPostingTable;
